import React from "react";
import { Link, useHistory, useLocation, useParams } from "react-router-dom";
import Header from "../common/Header";
import SideBar from "../common/SideBar";
import Button from "../common/Button/Button";
import PreviewDropdown from "../common/PreviewDropdown";
import { TrimText } from "../common/TrimText";
import { GlobalIconNames } from "../../utils/GlobalIconNames";
import { usePermissionGuardRedirect } from "../../hooks/usePermissionGuard";
import { useCareer } from "../../query/hooks/QueryHooksCareerLibrary";
import AuditTrail from "./AuditTrail";
import CareerDetails from "./CareerDetails";

//TODO: This should be configurable on website site settings in future
const aiePreviewData = { brand_ids: [1] };

function CareerOpenWrapper() {
  usePermissionGuardRedirect(["careerlibrarycareersview"]);
  const { tab, id } = useParams();
  const history = useHistory();
  const search = useLocation().search;
  const activeTab = tab || "details";

  const { data: career } = useCareer(id);

  const careerName = career?.name || new URLSearchParams(search).get("name");
  const careerSlug = career?.slug || "";
  const careerStatus = career?.publish_status || "";

  const detailsUrl = id ? `/career-library/careers/open/${id}/details` : "/career-library/careers/open";

  return (
    <>
      <Header></Header>
      <div
        className="content-wrapper d-flex flex-wrap new-standard-box"
      >
        <SideBar></SideBar>
        <div className={"sidebar-right " + (activeTab === "details" ? "bottom-100" : "")}>
          <div className="sub-menu-content-block">
            <div className="sub-menu-right-block">
              <div className="wrap-box-right">
                <div className="my-tickets-heading-blk flex-direction mb-2">
                  <div className="d-flex align-items-center flex-wrap">
                    <div className="name-w-head d-flex align-items-center">
                      <h4 className="text-left-align landing-heading heading_color_dynamic">
                        Career Library:{" "}
                        <span title={id ? careerName : "New Career"}>
                          {id ? TrimText(careerName || "", 60) : "New Career"}
                        </span>
                      </h4>
                    </div>
                    <div className="text-md-right action2-blk">
                      <div className="ticket-view-btn d-flex align-items-center">
                        <div className="add-new-ticket-bx">
                          {id && careerSlug ? (
                            <PreviewDropdown
                              updateData={aiePreviewData}
                              status={careerStatus}
                              isProgrammePage
                              pageUrl="career"
                              id={encodeURIComponent(careerSlug)}
                              buttonLabel="Website Page"
                              buttonIcon="fal fa-globe"
                              useAieButton
                              wrapperClassName="d-inline-block mr-2"
                            />
                          ) : null}
                          <Button
                            variant="secondary"
                            iconLeft={<i className="fal fa-chevron-left" />}
                            onClick={() => history.goBack()}
                            title="Back"
                            className="btn-white-bordered"
                          >
                            Back
                          </Button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="tabs-wrap">
                  <ul className="nav nav-pills mb-4" id="tabs" role="tablist">
                    <li className="nav-item" onClick={() => history.push(detailsUrl)}>
                      <Link
                        className={`nav-link ${activeTab === "details" ? "active" : ""}`}
                        id="pills-tab1"
                        data-toggle="pill"
                        to={detailsUrl}
                        role="tab"
                        aria-controls="pills-tab11"
                        aria-selected="true"
                      >
                        {GlobalIconNames("details").html}
                      </Link>
                    </li>
                    {id ? (
                      <li
                        className="nav-item"
                        onClick={() => history.push(`/career-library/careers/open/${id}/auditTrail`)}
                      >
                        <Link
                          className={`nav-link ${activeTab === "auditTrail" ? "active" : ""}`}
                          id="pills-tab2"
                          data-toggle="pill"
                          to={`/career-library/careers/open/${id}/auditTrail`}
                          role="tab"
                          aria-controls="pills-tab12"
                          aria-selected="false"
                        >
                          {GlobalIconNames("audittrail").html}
                        </Link>
                      </li>
                    ) : null}
                  </ul>
                  <div className="tab-content" id="pills-tabContent">
                    {activeTab === "details" ? <CareerDetails /> : null}
                    {activeTab === "auditTrail" && id ? <AuditTrail /> : null}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default CareerOpenWrapper;
